// This module exports a function to fetch parties data from the backend API
// Endpoint: GET /auth/addparty

import axios from 'axios';

const fetchStocks = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/auth/addstocks`
    );
    return response.data; // Array of party objects from the database
  } catch (error) {
    console.error('Error fetching parties:', error);
    return [];
  }
};

// For compatibility with original export
const stockes = fetchStocks;

export default stockes;

